import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { commonFunctionService } from "../utils/commonFunctions"
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { HeaderService } from '../header/header.service';
import { TranslateService } from '@ngx-translate/core';
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;
declare var document: any;
@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    providers: [ HeaderService]
})
export class MenuComponent implements OnInit {

    closeMobileMenu() {
        document.body.classList.remove('menubar-visible');
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (!document.body.classList.contains('menubar-visible')) {
            return;
        }
        const menubar = this.elementRef.nativeElement.querySelector('#menubar');
        const toggle = document.querySelector('.hv2-mobile-menu-toggle');
        const target = event.target as Node;
        if (menubar && menubar.contains(target)) {
            return;
        }
        if (toggle && toggle.contains(target)) {
            return;
        }
        this.closeMobileMenu();
    }

    permissions: any = { SCHOOL_STUDENT_MANAGEMENT: '', SCHOOL_STAFFS_MANAGEMENT: '' };
    adminType = "";
    loginMode = "";
    tcGeneratorEnabled: boolean = false;
    idCardGenerationEnabled: boolean = false;
    staffIdCardEnabled: boolean = false;
    idCardGenerated: boolean = false;
    openReport: boolean = false;
    certificateManagerEnabled: boolean = false;
    isReportServiceEnabled: boolean = false;
    isInsightsServiceEnabled: boolean = false;
    pageInfo: string = "";
    academicCalendarServiceEnabled = false;
    currentYear;
    schoolCurrency = "";
    getSchoolId;
    isFranchise;
    isPendingFeeServiceEnabled:any = false;
    isCheckinCheckoutServiceEnabled:any = false;
    hourhiveServiceEnabled: boolean = false;
    doorwayServiceEnabled : boolean = false;
    trackifyServiceEnabled : boolean = false;
    nexusServiceEnabled: boolean = false;
    brand = this.brandService.brand;
    constructor(private commonFunction: commonFunctionService, private router: Router,
          private headerservice: HeaderService, private translate: TranslateService,
          private elementRef: ElementRef, private brandService: BrandService
    ) {
      
        const extensionServices = localStorage.getItem('extensionServices')
        if (extensionServices === null || extensionServices === undefined) {
            localStorage.setItem('extensionServices', (this.getCookieValue('extensionServices')))
        } 
        if (extensionServices != null) {
            this.checkServiceStatus(extensionServices ? JSON.parse(extensionServices) : null)
        }
        const permissionList:any = this.getCookieValue('adminPermissionlist');
        const parsedPermissionList = JSON.parse(permissionList);
        const isFeeDashboardFeatureEnabled = localStorage.getItem('isFeeDashboardFeatureEnabled');
        this.isPendingFeeServiceEnabled = parsedPermissionList?.SCHOOL_FEES_DASHBOARD == 'ENABLED' ;
        if (isFeeDashboardFeatureEnabled != undefined || isFeeDashboardFeatureEnabled != null ){
            this.isPendingFeeServiceEnabled = isFeeDashboardFeatureEnabled;
        }
        this.loginMode = localStorage.getItem('loginMode');
        this.adminType = localStorage.getItem('adminType');
        this.schoolCurrency = localStorage.getItem('currency') || 'INR';
        this.getSchoolId = localStorage.getItem('schoolinfo');
    }

    ngOnInit() {
        const extensionServices = localStorage.getItem('extensionServices');
        if (extensionServices === null || extensionServices === undefined) {
            localStorage.setItem('extensionServices', (this.getCookieValue('extensionServices')))
        }
        if (extensionServices != null) {
            this.checkServiceStatus(extensionServices ? JSON.parse(extensionServices) : null);
        }
        const permissionList:any = this.getCookieValue('adminPermissionlist');
        const parsedPermissionList = JSON.parse(permissionList);
        const isFeeDashboardFeatureEnabled = localStorage.getItem('isFeeDashboardFeatureEnabled');
        this.isPendingFeeServiceEnabled = parsedPermissionList?.SCHOOL_FEES_DASHBOARD == 'ENABLED' ;
        if (isFeeDashboardFeatureEnabled != undefined || isFeeDashboardFeatureEnabled != null ){
            this.isPendingFeeServiceEnabled = isFeeDashboardFeatureEnabled;
        }
        this.checkSubLinksStatusReport(this.router.url);
        /* Right after login, localStorage's adminPermissionlist hasn't been
           written yet — the dashboard component only copies it over from the
           cookie once its own school-info API call resolves, which happens
           after this menu has already rendered. Fall back to the cookie
           (already set synchronously by login before navigation) so the menu
           shows every enabled feature on first render instead of only after
           a manual refresh. */
        let a = localStorage.getItem('adminPermissionlist');
        if (!a) {
            a = this.getCookieValue('adminPermissionlist');
            if (a) {
                localStorage.setItem('adminPermissionlist', a);
            }
        }
        /* loginMode and isFranchise gate the Dashboard/Insights menu items
           (see menu.component.html). The active login flow only ever writes
           these to cookies, never to localStorage, so — same race as
           adminPermissionlist above — they're missing here on first render
           right after login and only appear after a refresh re-derives them
           some other way. Fall back to the cookie and backfill localStorage. */
        this.loginMode = localStorage.getItem('loginMode');
        if (!this.loginMode) {
            const cookieLoginMode = this.getCookieValue('loginMode');
            if (cookieLoginMode) {
                this.loginMode = cookieLoginMode;
                localStorage.setItem('loginMode', cookieLoginMode);
            }
        }
        this.adminType = localStorage.getItem('adminType');
        this.schoolCurrency = localStorage.getItem('currency') || 'INR';
        this.getSchoolId = localStorage.getItem('schoolinfo');

        this.isFranchise = localStorage.getItem('isFranchise');
        if (!this.isFranchise) {
            const cookieIsFranchise = this.getCookieValue('isFranchise');
            if (cookieIsFranchise) {
                this.isFranchise = cookieIsFranchise;
                localStorage.setItem('isFranchise', cookieIsFranchise);
            }
        }
        if (!this.loginMode) {
            this.loginMode = 'WEB_ADMIN';
        }

        let currentTime = new Date();
        this.currentYear = currentTime.getFullYear();

        if (a) {
            this.permissions = JSON.parse(a);
        }
    }
    openCertificateManager() {
        window.open('https://recognify.bluewings.in/');
    }
    openReportTypes() {
        this.openReport = !this.openReport;
    }

    // function to check sub links open or not of reports
    // Transport stays highlighted on the new screen (/transport) and the legacy
    // one (/transport-v2); computed from the live URL so the paths never fight.
    get isTransportActive(): boolean {
        const url = this.router.url.split('?')[0].split('#')[0];
        return url === '/transport' || url === '/transport-v2' || url.startsWith('/transport/') || url.startsWith('/transport-v2/');
    }

    // Live check (pageInfo is only set once at init, so it goes stale on in-app navigation).
    // Fees Management stays highlighted on both the new screen (/fees) and the
    // legacy one (/fees-v2). Computed from the live router URL (not
    // routerLinkActive) so the two paths can never fight over the class.
    get isFeesActive(): boolean {
        const url = this.router.url.split('?')[0].split('#')[0];
        return url === '/fees' || url === '/fees-v2' || url.startsWith('/fees/') || url.startsWith('/fees-v2/');
    }

    checkSubLinksStatusReport(pageName) {
        this.pageInfo = pageName;
        if (pageName === "/report/transfer-certificate" || pageName === '/report/category-wise' || pageName === '/report/attendance-report' ||
            pageName === '/report/pending-fees' || pageName === "/report/expense-report" ||pageName === '/report/checkin-checkout-report' || pageName === '/report/fees-overdue-report'
        ) {
            this.openReport = true;
        }
    }

    // function for navigation to recognfiy page
    navigateReportSection(pageName) {
        this.router.navigate([pageName]);
    }

    // fetch cookie value from cookie data
    getCookieValue(cookieName) {
        const cookies = document.cookie.split("; ");
        for (let cookie of cookies) {
            const [key, value] = cookie.split("=");
            if (key === cookieName) {
                return decodeURIComponent(value);
            }
        }
        return null;
    }

async openExternalService(serviceName: string) {
    try {
        const storageKey = serviceName.toLowerCase() + 'ServiceDetails';
        const existingDetails = localStorage.getItem(storageKey);
        let finalURL: string;
            const response = await firstValueFrom(this.headerservice.generateTokenForService(serviceName));
            const data = response as any;
            if (data?.status) {
                const { serviceURL, token } = data.body;
                finalURL = this.buildServiceURL(serviceURL, token);
                localStorage.setItem(storageKey, JSON.stringify(data.body));
            } else {
                console.error(`${serviceName} Token Generation Failed:`, data);
                const failedToLoadServicePleaseTryAgainTranslations =  await firstValueFrom(this.translate.get('failedToLoadServicePleaseTryAgain'));
                customToastr(failedToLoadServicePleaseTryAgainTranslations, 'error');
                return;
            }
        window.open(finalURL, '_blank');
    } catch (error) {
        console.error(`Error opening ${serviceName}:`, error);
        const oopsSomethingWentWrongPleaseTryAgainTranslations =  await firstValueFrom(this.translate.get('oopsSomethingWentWrongPleaseTryAgain'));
        customToastr(oopsSomethingWentWrongPleaseTryAgainTranslations, 'error');
    }
}

buildServiceURL(serviceURL: string, token: string): string {
    if (serviceURL.includes('#')) {
        const [baseURL, hash] = serviceURL.split('#');
        const [hashPath, hashQuery] = hash.split('?');
        const newHashQuery = new URLSearchParams(hashQuery || '');
        newHashQuery.set('token', token);
        return `${baseURL}#${hashPath}?${newHashQuery.toString()}`;
    } else {
        const url = new URL(serviceURL);
        url.searchParams.set('token', token);
        return url.toString();
    }
}


    // function for check service status
    checkServiceStatus(servicesArray) {
        if (servicesArray && servicesArray.length > 0) {
            for (let i = 0; i < servicesArray.length; i++) {
                if ('REPORT' === servicesArray[i].serviceName) {
                    this.isReportServiceEnabled = servicesArray[i].serviceStatus === 'ENABLED' ? true : false;
                }
                  if ('AI_INSIGHTS' === servicesArray[i].serviceName) {
                    this.isInsightsServiceEnabled = servicesArray[i].serviceStatus === 'ENABLED' ? true : false;
                }
                if ('CERTIFICATE_MANAGER' === servicesArray[i].serviceName) {
                    this.certificateManagerEnabled = servicesArray[i].serviceStatus === 'ENABLED' ? true : false;
                }
                if ('TRANSFER_CERTIFICATE' === servicesArray[i].serviceName) {
                    localStorage.setItem('transferCertificate', servicesArray[i].serviceStatus === 'ENABLED' ? "true" : "false")
                    this.tcGeneratorEnabled = servicesArray[i].serviceStatus === 'ENABLED' ? true : false;
                }
                for (let i = 0; i < servicesArray.length; i++) {
                    if (servicesArray[i].serviceName === 'ID_CARD') {
                        this.idCardGenerationEnabled = servicesArray[i].serviceStatus === 'ENABLED';
                    }

                    if (servicesArray[i].serviceName === 'STAFF_ID_CARD') {
                        this.staffIdCardEnabled = servicesArray[i].serviceStatus === 'ENABLED';
                    }
                }
                this.idCardGenerated = this.idCardGenerationEnabled || this.staffIdCardEnabled;

                localStorage.setItem("idCardService", this.idCardGenerationEnabled ? "true" : "false");
                localStorage.setItem("staffIdCardService", this.staffIdCardEnabled ? "true" : "false");

                localStorage.setItem("idCardGenerated", this.idCardGenerated ? "true" : "false");


                if ("ACADEMIC_CALENDAR" === servicesArray[i].serviceName) {
                    this.academicCalendarServiceEnabled = servicesArray[i].serviceStatus === 'ENABLED' ? true : false;
                }
                if ("HOURHIVE" === servicesArray[i].serviceName) {
                    // localStorage.setItem('HOURHIVE', servicesArray[i].serviceStatus === 'ENABLED' ? "true" : "false")
                    this.hourhiveServiceEnabled = servicesArray[i].serviceStatus === 'ENABLED' ? true : false;
                }

                   if ("DOORWAY" === servicesArray[i].serviceName) {
                    // localStorage.setItem('HOURHIVE', servicesArray[i].serviceStatus === 'ENABLED' ? "true" : "false")
                    this.doorwayServiceEnabled = servicesArray[i].serviceStatus === 'ENABLED' ? true : false;
                }

                   if ("TRACKIFY" === servicesArray[i].serviceName) {
                    this.trackifyServiceEnabled = servicesArray[i].serviceStatus === 'ENABLED' ? true : false;
                }

                 if ("LIBRARY_MANAGEMENT" === servicesArray[i].serviceName) {
                    this.nexusServiceEnabled = servicesArray[i].serviceStatus === 'ENABLED' ? true : false;
                }
                if ("STUDENT_CHECK_IN_CHECK_OUT" === servicesArray[i].serviceName) {
                    this.isCheckinCheckoutServiceEnabled =servicesArray[i].serviceStatus === 'ENABLED' ? true : false;
                }
            }
        }
    }
}
